import type { Pipeline } from 'paintscout'
import { uuid } from '../..'

export function createPipeline(): Pipeline {
  return {
    key: uuid(),
    label: '',
    stages: [
      {
        key: uuid(),
        label: ''
      }
    ]
  }
}
